import React from "react";

export default function ConfirmationModal({
  show,
  onHide,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Update",
  cancelText = "Cancel",
}) {
  if (!show) return null;

  return (
    <div
      className="modal d-block"
      style={{
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 1060,
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div
          className="modal-content"
          style={{
            borderRadius: "12px",
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
          }}
        >
          {/* Header */}
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title fw-bold">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onHide}
            />
          </div>

          {/* Body */}
          <div className="modal-body pt-2 pb-4">
            <p className="text-muted fs-6 mb-4">{message}</p>

            <div className="d-flex justify-content-end gap-3">
              <button
                type="button"
                className="btn btn-light px-4"
                onClick={onHide}
                style={{
                  fontWeight: 500,
                }}
              >
                {cancelText}
              </button>

              <button
                type="button"
                className="btn px-4"
                onClick={onConfirm}
                style={{
                  backgroundColor: "#000",
                  color: "#fff",
                  fontWeight: 500,
                  borderRadius: "6px",
                }}
              >
                {confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
